import React, { useEffect } from "react";
import { Container } from "@mui/material";
import ParticlesBg from "particles-bg";
import "../utils/collagestyles.css";
import NavMenu from "./Menu";
import { useDispatch, useSelector } from "react-redux";
import { fetchImagesByPet } from "./imageStore";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const Collages = () => {
  const dispatch = useDispatch();
  const { data: images, loading, error } = useSelector((state) => state.images);
  const activePet = useSelector((state) => state.activePet);

  useEffect(() => {
    console.log("Active pet changed:", activePet);
    if (activePet) {
      dispatch(fetchImagesByPet(activePet));
    }; 
    console.log("Images for pet:", images);
  }, [dispatch, activePet]);

  return (
    <>
      <NavMenu />
      <ParticlesBg type="circle" margin="5px" bg={true} />

      <Container align="center" maxWidth="sm">
        <h2>
          <p>Knight's Kennel</p>
        </h2>
      </Container>

      {!activePet && <p>No pet selected.</p>}

      {activePet && (
        <>
          {loading && <p>Loading images for {activePet.name}...</p>}
          {error && <p style={{ color: "red" }}>Error: {error}</p>}

          {!loading && !error && (
            <ul className="flexcontainer">
              {images.map((filename) => (
                <div key={filename} className="card">
                  <LazyLoadImage
                    src={`http://localhost:8000/${filename}`}
                    alt="knights kennel miniature schnauzers new england rhode island"
                    effect="blur"
                    width="300"
                  />
                </div>
              ))}
            </ul>
          )}
        </>
      )}
    </>
  );
};

export default Collages;
